<form [formGroup]="form" (ngSubmit)="submit()">
  <app-picklist [formControl]="form.controls['insertionCycles']"
                [source]="availableInsertionCycles"
                formControlName="insertionCycles"
                [dragDrop]="isSPI"
                sourceHeader="{{'admin.tools.create-modal.pick-list.insertionCycles.leftHeader' | translate}}"
                targetHeader="{{'admin.tools.create-modal.pick-list.insertionCycles.rightHeader' | translate}}">
  </app-picklist>
</form>